module.exports = __webpack_public_path__ + "static/inconsolata-latin-400.04bce193.woff";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-inconsolata/files/inconsolata-latin-400.woff
// module id = ./node_modules/typeface-inconsolata/files/inconsolata-latin-400.woff
// module chunks = 17241999800008180000